import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { fiscalPeriod, FiscalPeriodManipulationViewModel } from "./fiscalPeriodManipulation-viewModel"

export class FiscalPeriodManipulationView extends View<FiscalPeriodManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-D0D19C50-96D3-4C64-9474-17C3253F0635"
    }
    loadHtml(): string {
        let element = require('./fiscalPeriodManipulation.html').default;
        let style = require('./fiscalPeriodManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set fiscalPeriod(v: ObservableArray<fiscalPeriod>) { this._fiscalPeriod = v; } public get fiscalPeriod(): ObservableArray<fiscalPeriod> { return this._fiscalPeriod;} private _fiscalPeriod: ObservableArray<fiscalPeriod>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;
    
    requestFiscalPeriodCreation(){
        this.dataContext.requestFiscalPeriodCreation();
    }
}
